import { GetAllClinicalDocsByCode } from '~/domain/usecases/clinicalDocs/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteGetAllClinicalDocsByCode
  implements GetAllClinicalDocsByCode
{
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllClinicalDocsByCode.Model>;

  constructor(
    url: string,
    httClient: HttpClient<GetAllClinicalDocsByCode.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  getAll = async (
    params: GetAllClinicalDocsByCode.Params,
  ): Promise<GetAllClinicalDocsByCode.Model> => {
    let query = '';

    const { code, ...rest } = params;

    Object.entries(rest).forEach(([key, value]) => {
      if (value) query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url.replace('{code}', code)}?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
